<template>
  <b-form-group :label="label" :description="description">
    <b-form-checkbox v-model="inputValue" :id="id" switch size="lg" />
  </b-form-group>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "FormFieldToggle",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: [Boolean],
      default: false,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    enabledText: {
      type: String,
      default: "Enabled",
    },
    disabledText: {
      type: String,
      default: "Disabled",
    },
  },
  setup(props, { emit }) {
    const inputValue = ref(
      props.value === null || props.value === undefined ? false : props.value
    );

    watch(
      () => props.value,
      (newValue) => {
        inputValue.value =
          newValue === null || newValue === undefined ? false : Boolean(newValue);
      }
    );

    watch(
      () => inputValue.value,
      (newValue) => {
        emit("input", newValue);
      }
    );

    return {
      inputValue,
    };
  },
};
</script>
